// Symbol for the injection key
const NotificationSymbol = Symbol('Notification')

// Global event bus for notifications
const notificationBus = {
  listeners: new Set(),
  emit(notification) {
    this.listeners.forEach(listener => listener(notification))
  },
  subscribe(listener) {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }
}

export function useNotification() {
  const notify = ({
    message,
    title = 'Notification',
    type = 'info',
    icon = null,
    component = null,
    horizontalAlign = 'right',
    verticalAlign = 'top',
    notificationJsonMessage = null
  }) => {
    notificationBus.emit({
      message,
      title,
      type,
      icon,
      component,
      horizontalAlign,
      verticalAlign,
      notificationJsonMessage
    })
  }

  return { notify }
}

export function useNotificationListener() {
  return {
    subscribe: notificationBus.subscribe.bind(notificationBus)
  }
}

export default {
  install: (app) => {
    const { notify } = useNotification()

    // global method for class-based components
    app.config.globalProperties.$notify = notify

    // global methode for composition API
    app.provide(NotificationSymbol, { notify })
  }
}
